import { environment } from '@environments/environment';

export const tinyDefaultConfig = {
  browser_spellcheck: true,
  language_url: environment.publicFolder + 'assets/tinymce/de.js',
  language: 'de',
  menubar: false,
  plugins: 'lists link autolink',
  // toolbar_mode: 'wrap',
  toolbar: 'bold italic | numlist bullist | link | undo redo',
  // | h1 h2
  formats: {
    // Changes the default format for h1 to have a class of heading
    // h1: { block: 'h2', classes: 'headline-tiny' },
    // h2: { block: 'h3', classes: 'sub-headline-tiny' },
    bold: { inline: 'b', classes: 'bold' },
    italic: { inline: 'i', classes: 'italic' },
  },
  height: 250,
  contextmenu: '', // use native context menu because tiny context menu copy paste don't work
  branding: false,

  // link handling
  link_default_target: '_blank',
  link_target_list: false,
  link_assume_external_targets: 'https',
  relative_urls: false,

  // throw formatting when pasting text from word etc.
  paste_as_text: true,
};
